import 'hint.css/hint.css'
import _ from 'lodash'
export default {
    /**
     * tooltip
     *
     * 使用方式:
     *
     * 1 静态 title : <span v-tooltip title="你好啊" > Hello World </span>
     * 2 动态 title : <span v-tooltip:title="msg"> Hello World </span>
     *
     * placement: String 位置 top left right bottom topLeft topRight bottomLeft bottomRight
     *
     * title: String 文字
     *
     * rounded: Boolean 是否显示为圆角边框
     *
     * no-animate: Boolean 去掉动画
     *
     * bounce: Boolean 弹出动画
     *
     * color: String 主题颜色 success, info, warning, error
     *
     * always: Boolean 一直显示, 不隐藏 tooltip
     *
     * reference : https://github.com/chinchang/hint.css
     */
    params: [ 'placement', 'title', 'rounded', 'no-animate', 'bounce', 'color', 'always' ],
    update(value) {
        if (!value && !this.params.title) {
            return
        }
        this.el.setAttribute('data-hint', value || this.params.title)
        let classList = []
        classList.push(this.params.placement ? `hint--${_.kebabCase(this.params.placement)}` : 'hint--top')
        this.params.rounded && classList.push('hint--rounded')
        this.params.noAnimate && classList.push('hint--no-animate')
        this.params.always && classList.push('hint--always')
        this.params.bounce && classList.push('hint--bounce')
        this.params.color && classList.push(`hint--${this.params.color}`)
        this.el.className += ` ${classList.join(' ')}`
    }
}


// WEBPACK FOOTER //
// ./bootsets/directives/tooltip.js